<template>
  <v-container fluid id="contacts" pa-0>
    <v-footer fluid dark color="#3055a2" tile style="margin-bottom: 20px">
      <v-col>
        <v-col align="center" justify="center" class="text-center py-0">{{$t('contacts.address')}}</v-col>
        <v-col align="center" justify="center" class="text-center py-0"><a :href="`mailto:${$t('contacts.email')}`">{{$t('contacts.email')}}</a></v-col>
        <v-col align="center" justify="center" class="text-center py-0">{{$t('contacts.phone1')}}</v-col>
        <v-col align="center" justify="center" class="text-center py-0">{{$t('contacts.phone2')}}</v-col>
        <v-col align="center" justify="center" class="text-center py-0">{{$t('contacts.copyright')}}</v-col>
      </v-col>
    </v-footer>
    <v-row class="bottom-stripes"></v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'Contacts'
  }
</script>

<style scoped>
  #contacts {
    background-color: #3055a2;
  }

  #contacts a {
    color: white;
  }

  .bottom-stripes {
    height: 40px;
    background: repeating-linear-gradient(
      110deg,
      #3055a2,
      #3055a2 20px,
      #000032 20px,
      #000032 40px
    );
  }
</style>
